import React, { Component } from 'react';

import { compose } from 'react-apollo';
import { gql } from '@apollo/client';
import { graphql } from '@apollo/client/react/hoc';

import Statistics from './Statistics';


class StatisticsFiltered extends Component{
  render() {

    const {data: {loading, statistics, refetch}, app_data, filter_data} = this.props;

    if(loading) {
      return (<div>Загрузка</div>);
    }

    return (

      <div>
        <Statistics
          statistics={statistics}
          app_data={app_data}
          filter_data={filter_data}
          refetch={refetch}
          with_client={true}/>
      </div>

    );
  }
}


export default compose(
  graphql(gql`query statistics(
      $start_date: String!,
      $end_date: String!,
    ){
    statistics(start_date: $start_date, end_date: $end_date){
      operators {
        operators_by_close {
          id,
          payed_deliveries_created_count,
          payed_deliveries_money_sum,
          created_in_place_count,
          payed_created_in_place_count,
          payed_created_in_place_money_sum,
          confirmed_count,
          payed_confirmed_count,
        },
        operators_by_creation {
          id,
          leads_created,
          deliveries_created,
          created_in_place_count,
        }
      }
    }
  }`, {
    options: ({filter_data: {
      start_date,
      end_date,
    }}) => {

      return {
        variables: {
          start_date: start_date.toDate(),
          end_date: end_date.toDate(),
        }
      }

    }
  }),


)(StatisticsFiltered);